import * as React from "react";
import { useHistory } from "react-router-dom";
import Modal from "../../misc/components/modal";
import { ErrorBoundary } from "../../errors/ErrorBoundary";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import AsyncActionButton from "../../misc/components/AsyncActionButton";

export const UseUnsavedChangesNavigationInterceptor = (props) => {
    // State hooks
    const { when } = props
        , history = useHistory()
        , [showPrompt, setShowPrompt] = React.useState<boolean>(false)
        , [currentPath, setCurrentPath] = React.useState<string>(null)
        , unblockRef = React.useRef<unknown>();

    // UI interaction handlers
    const onCancel = () => setShowPrompt(false),

        handleConfirm = () => {
            unblockRef && (unblockRef.current as Function)();
            setShowPrompt(false);
            history.push(currentPath);},

        onNavigate = (location: any): any => {
            when && (() => {
                setCurrentPath(location.pathname);
                setShowPrompt(true);
            })();
            return !when;};

    // Listener
    React.useEffect(() => {
        unblockRef.current = history.block(onNavigate);
        return () => unblockRef.current && (unblockRef.current as Function)();
    }, [when]);

    return (<Modal show={showPrompt} closeModalHandler={onCancel} header="Unsaved Changes">
            <ErrorBoundary>
                <div className="modal-body">
                    <p>There are unsaved changes. Are you sure want to leave this page?</p>
                </div>
                <div className="modal-footer">
                    <AsyncActionButton className="btn btn-danger" type="submit" isSubmitting={false} onClick={handleConfirm}>
                        Leave
                    </AsyncActionButton>
                    <button className="btn btn-outline btn-primary" onClick={onCancel}>Continue</button>
                </div>
            </ErrorBoundary>
        </Modal>);
}
